__turbopack_context__.v({
  "load": "skeleton-module-scss-module__KrDDFG__load",
  "skeleton": "skeleton-module-scss-module__KrDDFG__skeleton",
});
